import { useEffect, useRef } from "react";

export default function MesaHeroSection() {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const img = el.querySelector(".hero-bg") as HTMLElement;
    if (!img) return;
    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / rect.height));
      img.style.transform = `translateY(${progress * 80}px) scale(1.05)`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section ref={heroRef} className="relative h-[420px] md:h-[600px] overflow-hidden">
      <div className="hero-bg absolute inset-0 bg-cover bg-center transition-transform duration-100 will-change-transform" style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Beautiful%20Arizona%20East%20Valley%20cityscape%20at%20dusk%20with%20Mesa%20Arizona%20temple%20distant%20mountain%20view%20warm%20golden%20light%20urban%20suburban%20blend%20cinematic%20travel%20photography%20no%20text%20no%20people&width=1600&height=900&seq=mesa-hero-001&orientation=landscape')" }}></div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A365D]/40 via-[#1A365D]/30 to-[#1A365D]/60"></div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 max-w-5xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-md rounded-full px-4 py-1.5 mb-6">
          <i className="ri-map-pin-2-line text-[#F6C344] text-sm"></i>
          <span className="text-white/90 text-xs font-semibold tracking-wide">Mesa, Arizona — East Valley's Largest City</span>
        </div>
        <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          Mesa Emergency Passport<br className="hidden md:block" />
          <span className="text-[#F6C344]">Expedited Service</span>
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Expedited passport services in Mesa, AZ — as fast as 24 hours. Serving Boeing workers, Gateway Airport travelers, Mesa Arts Center visitors, large families, and East Valley's diverse international community.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-10">
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">
            Start My Passport
            <i className="ri-arrow-right-line"></i>
          </a>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 text-white hover:text-[#F6C344] font-medium text-base transition-colors whitespace-nowrap">
            <i className="ri-phone-line text-[#F6C344]"></i>
            877-253-0084
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6">
          {[{ icon: "ri-time-line", text: "As Fast as 24 Hours" }, { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" }, { icon: "ri-award-line", text: "A+ BBB Rating" }, { icon: "ri-price-tag-3-line", text: "Best Price Guarantee" }].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/70 text-sm">
              <i className={`${badge.icon} text-[#F6C344]`}></i>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}